import { cn } from "@/lib/utils"

export type CardProps = {
  id?: string
  className?: string
  children: React.ReactNode
  ref?: React.Ref<HTMLDivElement>
}

export function Card({ id, className, children, ref, ...rest }: CardProps) {
  return (
    <div
      id={id}
      ref={ref}
      className={cn("rounded-md border border-border bg-white p-5", className)}
      {...rest}
    >
      {children}
    </div>
  )
}
